import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const getDonationPackages = () => api.get("/donations/packages").then((r) => r.data);

export const createDonationCheckout = (payload) =>
  api.post("/donations/checkout", payload).then((r) => r.data);

export const getDonationStatus = (sessionId) =>
  api.get(`/donations/status/${sessionId}`).then((r) => r.data);
